module.exports = __webpack_public_path__ + "static/img/ls8.288bbc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls8.png
// module id = AyYt
// module chunks = 12